// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/class-f-id-code.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/class-f-id-code/class-f-id-code.js';

mount([g0]);
